export const PLATFORM_MODULES = {
  MI_DISPATCH: "MiDispatch",
  MI_SCHEDULING: "MiScheduling",
  MI_ACCOUNTING: "MiAccounting",
  MI_INSPECTIONS: "MiInspections",
  MI_ESTIMATING: "MiEstimating",
  // TODO: Add when MiAI module is planned
  // MI_AI: "MiAI",
};

export const PLATFORM_MODULES_OPTIONS = [
  {
    label: PLATFORM_MODULES.MI_DISPATCH,
    value: PLATFORM_MODULES.MI_DISPATCH,
  },
  {
    label: PLATFORM_MODULES.MI_SCHEDULING,
    value: PLATFORM_MODULES.MI_SCHEDULING,
  },
  {
    label: PLATFORM_MODULES.MI_ACCOUNTING,
    value: PLATFORM_MODULES.MI_ACCOUNTING,
  },
  // TODO: Add when MiInspections module is planned
  // {
  //   label: PLATFORM_MODULES.MI_INSPECTIONS,
  //   value: PLATFORM_MODULES.MI_INSPECTIONS,
  // },

  // TODO: Add when MiEstimating module is planned
  // {
  //   label: PLATFORM_MODULES.MI_ESTIMATING,
  //   value: PLATFORM_MODULES.MI_ESTIMATING,
  // },
];
